<template lang="html">
  <div class="inner-modal">
    <div class="body-modal">
      <div class="title-gold">
        Informations Légales - Personne Morale
      </div>
      <div class="body-standard">
        <p>Conformément aux principes de la loi du 6 janvier 1978 relative à l'informatique aux fichiers et aux libertés modifié par le décret n°2019-536 ainsi qu'au règlement général à la protection des données entrée en vigueur le 25 mai 2018 nous vous rappelons que la présente collecte d'information ainsi que leur exploitation sont effectuées dans votre intérêt et ont pour finalité de permettre au professionnel d'établir un profil de risque dans le but de fournir un conseil adapté à votre problématique.</p>
        <p>La qualité de son travail dépendra étroitement de la véracité, de l'exactitude et de l'exhaustivité de vos réponses à ce questionnaire.</p>
        <p>Si vous ne communiquez pas les informations requises, votre conseiller ne pourra pas poursuivre sa mission et devra s'abstenir de vous recommander les opérations, instruments et services relevant de son activité CIF.</p>
        <p>Il ne pourra vous fournir qu'une prestation d'information ou de recherche, une mission relevant d'un autre métier réglementé ou de la sphère non financière.</p>
        <p>Vous reconnaissez avoir connaissance des tarifs de votre conseiller, de ses méthodes de travail et avoir en votre possession sa fiche d'information légale ANACOFI.</p>
        <p>Votre conseiller s'est engagé au respect de règles de bonne conduite incluant le secret professionnel et la protection de vos données personnelles.</p>
        <p>Les informations recueillies sont enregistrées dans un fichier informatisé par Patrimoffice afin notamment de pouvoir proposer des produits et services de qualité personnalisés et adaptés à chaque situation patrimoniale, besoin et objectif recherché, se conformer à ses obligations légales et règlementaires et exercer son activité de conseil et de suivi au mieux des intérêts des clients. Elles sont conservées pendant la durée de la relation contractuelle et pendant 5 ans à l'issue de la relation et sont destinées aux établissements dépositaires ou compagnies d'assurance à partenaires de Patrimoffice, et le cas échéant à son prestataire de services informatiques. Ces données ne font l'objet d'aucune transmission à des organismes extérieurs notamment à des fins de prospection commerciale sans l'accord du client.</p>
        <p>Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès, d'opposition, d'effacement, de limitation du traitement, de portabilité des données vous concernant et les faire rectifier en contactant notre service de traitement des données à contact@patrimoffice.com. Vous pouvez également introduire une réclamation au sujet du traitement de vos données auprès de la CNIL.</p>

        <div class="title-grey">
          Obligations spécifiques aux personnes morales
        </div>
        <p>Dans le cadre de la lutte contre le blanchiment de capitaux et le financement du terrorisme (LCB-FT), les informations relatives à la société, ses dirigeants et bénéficiaires effectifs sont obligatoires.</p>
        <p>Les documents justificatifs demandés (K-bis de moins de 3 mois, statuts, bilan/compte de résultat) sont nécessaires pour la conformité réglementaire et doivent être transmis avant toute opération d'investissement.</p>
        <p>Le représentant légal signataire certifie disposer des pouvoirs nécessaires pour engager la société et garantit l'exactitude des informations communiquées.</p>
      </div>
      <div class="ctn-cta row">
        <div class="btn btn-gold" @click="close">Fermer</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RgpdCompany',
  methods: {
    close () {
      this.$emit('close')
    }
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style lang="scss" scoped>
  .body-modal {
    max-width: 700px;
    padding: 4rem !important;
    max-height: 80vh;
    overflow-y: auto;
  }

  .title-gold {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    color: #c4996e;
    font-family: "Lato Bold";
  }

  .title-grey {
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 1rem;
    font-family: "Lato Bold";
    color: #666;
  }

  .body-standard {
    font-size: 0.9rem;
    margin: 1rem 0;
    line-height: 1.6;

    p {
      margin-bottom: 0.75rem;
      text-align: justify;
    }
  }

  .ctn-cta {
    margin-top: 3rem;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// RgpdCompany.vue?5ce76f52